document.addEventListener('alpine:init', () => {
    window.Alpine.magic('localStorage', () => (localStorageKeysObject) => {
        const localStorageKeys = localStorageKeysObject.data;
        const localStorageKey = Object.keys(localStorageKeys)[0];
        const form = document.getElementsByName(localStorageKey)[0];

        /**
         * Saves a key value pair to the local storage.
         * 1. Line: Data structure map gets instantiated by reading the localstorage
         * 2. Line: A key-value is added to that data structure
         * 3. Line: The data structure is getting stringyfied and saved to localstorage.
         *
         * @param key to save in local storage
         * @param value to save in local storage
         * @param localStorageKey key to read from the localstorage
         */
        function saveFromFieldToLocalStorage(key, value, localStorageKey = 'wizardStepOne'){
            const formFields = new Map(JSON.parse(localStorage.getItem(localStorageKey)));
            formFields.set(key, value);
            localStorage.setItem(localStorageKey, JSON.stringify([...formFields.entries()]));
        }

        // Prefill form
        const prefilledFormFields = new Map(JSON.parse(localStorage.getItem(localStorageKey)));
        if(prefilledFormFields.size > 0) {
            for (const item of localStorageKeys[localStorageKey]) {
                if (prefilledFormFields.get(item) !== undefined && prefilledFormFields.get(item) !== '' && item !== 'phone_prefix') {
                    const label = form.querySelector(`[for="${item}"]`);
                    if (label !== undefined){
                        const formfield = form.querySelector(`[name="${item}"]`);
                        formfield.value = prefilledFormFields.get(item);
                        formfield.dispatchEvent(new Event('change'));
                        formfield.parentElement.classList.add(['is-focused']);
                    }
                }
            }
        }

        // Gather Data to prefill form on page reload
        form.addEventListener("focusout", (e) => {
            const wizardFields = localStorageKeys[localStorageKey];

            /**
             * We save all fields for every event.
             * That way, we can assure that Browser autofills get saved in the localstorage.
             * So let's iterate over all wizard fields and save them to the localstorage:
             */
            wizardFields.forEach( key => {
                const value = document.getElementById(key).value;
                saveFromFieldToLocalStorage(key, value, localStorageKey);
            });
        });
    });
});
